import { createApi } from "../axiosInstance";
import { createActivitiesApi } from "../shared/activitiesApiFactory";

const api = createApi("myFPO");

export const {
  registerLegalCompliance,
  getLegalCompliance,
  getLegalComplianceByTenant,
  updateLegalComplianceStatus,
  registerAnnualCompliance,
  getAnnualCompliance,
  getAnnualComplianceByTenant,
  updateAnnualComplianceStatus,
  registerCapacityBuilding,
  getCapacityBuilding,
  getCapacityBuildingByTenant,
  updateCapacityBuildingStatus,
  registerBusiness,
  getBusiness,
  getBusinessByTenant,
  updateBusinessStatus,
  addAGMBoards,
  getAGMBoards,
  getAgmDocuments,
  getMyAgmOrganisations,
  uploadAgmDocuments,
  updateAgmDocument,
  getMembershipDashboard,
  getShareCapitalDashboard,
  getTurnoverDashboard,
} = createActivitiesApi(api, "MY_ORG");
